<div class="loading" *ngIf="picsNotLoadedYet"></div>
<ngx-gallery class="images-rounded" *ngIf="showGallery && galleryOptions" [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
